import { render, staticRenderFns } from "./SolicitacaoCirurgiaActions.vue?vue&type=template&id=f47f13fc&scoped=true"
import script from "./SolicitacaoCirurgiaActions.vue?vue&type=script&lang=ts"
export * from "./SolicitacaoCirurgiaActions.vue?vue&type=script&lang=ts"
import style0 from "./SolicitacaoCirurgiaActions.vue?vue&type=style&index=0&id=f47f13fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47f13fc",
  null
  
)

export default component.exports